export const width=1891;export const height=921;export default{width:width,height:height};